
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogrishneshwarjyotilinga() {



    const cardData =
    {
        keyword: 'Pune to Grishneshwar Jyotirlinga Cab',
        heading: 'Meghana Cab : Pune to Grishneshwar Jyotirlinga Cab',
        headingDescription: 'Meghana Cab offers Pune to Grishneshwar Jyotirlinga Cab services, providing a peaceful and convenient travel experience for devotees visiting one of the most revered Jyotirlingas in India. Located near Ellora Caves in Aurangabad, Grishneshwar Temple attracts pilgrims from across the country, and our professional cab service ensures you reach the shrine safely and comfortably. Covering approximately 260 kilometers, the route offers a smooth highway journey with scenic views. Choose from a wide range of clean, air-conditioned sedans, SUVs, and tempo travellers to suit your travel needs. With punctual pickups, courteous drivers, and round-the-clock support, Meghana Cab makes your Pune to Grishneshwar Darshan trip divine, affordable, and hassle-free.',


        top: 'Top Places to Visit in Grishneshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple, located near Ellora in Aurangabad, Maharashtra, is the twelfth and final Jyotirlinga of Lord Shiva, symbolizing compassion and divine energy. The temple’s red-stone structure, built in the 18th century by Queen Ahilyabai Holkar, showcases exquisite carvings and ancient architectural grace. The sanctum houses the sacred Jyotirlinga, worshipped by devotees seeking peace and prosperity. Daily rituals, abhisheks, and the evening aarti fill the air with divine vibrations. Photography is restricted to preserve sanctity, allowing visitors to fully immerse in devotion. Its proximity to Ellora Caves and Daulatabad Fort makes it a spiritual and cultural landmark of Maharashtra."
  },
  {
    "title": "Ellora Caves (UNESCO World Heritage Site)",
    "description": "Just 1 km from Grishneshwar Temple, the Ellora Caves are a magnificent blend of art, faith, and history. Carved between the 6th and 10th centuries, the site features 34 rock-cut temples representing Hindu, Buddhist, and Jain traditions. The most famous among them, Kailasa Temple (Cave 16), is a monolithic marvel dedicated to Lord Shiva, intricately carved from a single rock. Visitors can explore centuries of craftsmanship, divine sculptures, and architectural genius. The caves, with their spiritual aura and artistic brilliance, complement the Jyotirlinga pilgrimage with an unforgettable historical experience."
  },
  {
    "title": "Daulatabad Fort",
    "description": "About 12 km from Grishneshwar, Daulatabad Fort stands as a symbol of medieval military strength and architectural mastery. Originally known as Devagiri, the fort rises dramatically atop a conical hill. It was once the capital of the Tughlaq dynasty under Sultan Muhammad bin Tughlaq. The fort complex includes massive gates, secret passages, and the impressive Chand Minar. Climbing to the top offers panoramic views of the surrounding landscape. For pilgrims visiting Grishneshwar, a trip to Daulatabad blends spirituality with a glimpse into India’s grand historical past."
  },
  {
    "title": "Bhadra Maruti Temple – Khuldabad",
    "description": "Located just 4 km from Grishneshwar, the Bhadra Maruti Temple in Khuldabad is dedicated to Lord Hanuman in a unique sleeping posture. Legend says Lord Hanuman rested here listening to King Bhadrasena’s hymns in devotion to Lord Rama. The temple’s tranquil atmosphere, rhythmic chanting, and marble interiors make it a peaceful spiritual retreat. During Hanuman Jayanti and Ram Navami, the temple is filled with festive fervor. Pilgrims often visit this shrine before proceeding to Grishneshwar for blessings of strength, humility, and divine protection."
  },
  {
    "title": "Khuldabad – Valley of Saints",
    "description": "Khuldabad, also known as the ‘Valley of Saints,’ lies close to the Grishneshwar Temple and holds immense spiritual significance. It houses the tombs of several Sufi saints and the mausoleum of Mughal Emperor Aurangzeb, who lived his final years here as a devotee of Lord Shiva. The quiet dargahs, ancient mosques, and serene surroundings reflect India’s syncretic spiritual heritage. The town represents harmony between Hindu and Islamic traditions. Pilgrims visiting Grishneshwar often include Khuldabad in their itinerary for its profound historical and devotional importance."
  },
  {
    "title": "Panchakki (Water Mill) – Aurangabad",
    "description": "Situated about 30 minutes from Grishneshwar, Panchakki is a 17th-century engineering marvel that once powered a flour mill using water channeled through underground pipes from a distant spring. The site features a peaceful garden, a mosque, and the tomb of a Sufi saint, Baba Shah Musafir. The mill’s ingenious design demonstrates the scientific excellence of medieval India. Its calm surroundings, reflective pools, and architectural charm make Panchakki a refreshing detour for travelers seeking both history and tranquility after visiting Grishneshwar."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Located on a hill near Bibi Ka Maqbara, the Aurangabad Caves comprise 12 ancient rock-cut Buddhist caves dating back to the 6th–7th centuries. These lesser-known yet stunning caves display carvings of Bodhisattvas, apsaras, and intricate chaitya halls. Overlooking lush valleys, they offer a peaceful escape from the city. Their proximity to Grishneshwar and Ellora makes them a valuable addition for travelers exploring Aurangabad’s spiritual and historical treasures. The caves serve as a reminder of India’s ancient artistic brilliance and religious harmony."
  },
  {
    "title": "Bibi Ka Maqbara – Mini Taj Mahal",
    "description": "Often called the ‘Taj of the Deccan,’ Bibi Ka Maqbara was built by Azam Shah in memory of his mother, Rabia Durrani, in the 17th century. This elegant marble mausoleum bears a striking resemblance to the Taj Mahal. Set against the backdrop of the Aurangabad hills, its symmetry and Mughal architecture captivate visitors. Evening illumination enhances its beauty, making it a photographer’s delight. Pilgrims visiting Grishneshwar often explore Bibi Ka Maqbara to admire the grandeur and artistic heritage of the Mughal era intertwined with local culture."
  },
  {
    "title": "Pitalkhora Caves",
    "description": "Located about 40 km from Grishneshwar, the Pitalkhora Caves are among the oldest Buddhist cave complexes in Maharashtra. Nestled in the Satmala ranges, these 14 rock-cut caves feature beautiful sculptures of elephants, lions, and yakshas. The site offers scenic beauty, surrounded by waterfalls during monsoon. Archaeological evidence suggests these caves once served as a major monastic center. For visitors to Grishneshwar, Pitalkhora offers a tranquil combination of nature, art, and history, providing insight into India’s early Buddhist heritage."
  },
  {
    "title": "Salim Ali Lake and Bird Sanctuary",
    "description": "Named after India’s renowned ornithologist Dr. Salim Ali, this lake and sanctuary in Aurangabad is a serene haven for nature lovers. Spread across a large wetland area, it attracts migratory birds like flamingos, herons, and egrets. Visitors can enjoy boating, photography, or simply relax amid the chirping of birds. The sanctuary serves as an ecological balance to Aurangabad’s cultural circuit. After visiting Grishneshwar Temple, it offers travelers a refreshing encounter with nature’s beauty and biodiversity."
  }
],

   "services": [
    {
      "name": "Pune to Ajanta Ellora Tour Package",
      "description": "Explore the UNESCO World Heritage Sites of Ajanta and Ellora with Meghana Cab’s Pune to Ajanta Ellora tour package. Our well-planned package includes comfortable AC cab travel, professional drivers, and flexible itineraries that let you explore the ancient caves, temples, and sculptures of Maharashtra’s most iconic heritage sites. Visit the Ellora Caves, Grishneshwar Jyotirlinga Temple, and the Ajanta Caves all in one trip. Whether you’re a history lover, spiritual traveler, or family tourist, our package provides a blend of culture, comfort, and convenience. Enjoy seamless travel with on-time pickups, clean vehicles, and affordable pricing. Book your Ajanta Ellora trip from Pune today for a memorable and educational journey with Meghana Cab."
    },
    {
      "name": "Pune to Grishneshwar Jyotirlinga Cab",
      "description": "Book your Pune to Grishneshwar Jyotirlinga cab with Meghana Cab for a divine and comfortable journey to one of the most sacred Shiva temples. Located near the Ellora Caves in Aurangabad, Grishneshwar is one of the 12 Jyotirlingas of India. Our cab service provides air-conditioned vehicles, experienced chauffeurs, and flexible pickup options from anywhere in Pune. Whether you’re traveling for darshan, sightseeing, or as part of a Jyotirlinga tour, Meghana Cab ensures smooth, safe, and timely travel. Combine your visit with Ajanta and Ellora for a complete spiritual and historical experience. Book now for a peaceful Pune to Grishneshwar cab service."
    },
    {
      "name": "Pune to 3 Jyotirlinga Tour Package",
      "description": "Embark on a divine 3 Jyotirlinga tour from Pune with Meghana Cab. This popular pilgrimage route covers Bhimashankar, Trimbakeshwar, and Grishneshwar Jyotirlingas—three of Maharashtra’s most sacred temples. Our package includes AC cab travel, courteous drivers, customizable itineraries, and flexible pickup and drop options. Enjoy spiritual serenity, scenic routes, and comfortable travel all in one journey. Whether you’re traveling with family, friends, or a religious group, Meghana Cab ensures a safe, reliable, and spiritually enriching pilgrimage. Book your 3 Jyotirlinga tour package from Pune today and experience devotion with comfort and convenience."
    },
    {
      "name": "Pune to Aurangabad Cab Service",
      "description": "Travel from Pune to Aurangabad comfortably with Meghana Cab’s reliable intercity cab service. Known for its historical landmarks like Ajanta Caves, Ellora Caves, and Bibi Ka Maqbara, Aurangabad is a favorite destination for both pilgrims and tourists. Our AC cabs and experienced drivers ensure smooth travel with timely pickups and drops. Choose from sedans, SUVs, or Innovas depending on your comfort and group size. Perfect for sightseeing, corporate travel, or family trips, our Pune to Aurangabad taxi service combines affordability with reliability. Book online today for a comfortable and memorable trip to Aurangabad."
    },
    {
      "name": "Pune to Sambhajinagar Cab Service",
      "description": "Book Meghana Cab’s Pune to Sambhajinagar cab service (formerly Aurangabad) for a comfortable and stress-free intercity journey. Visit iconic sites such as Ellora Caves, Bibi Ka Maqbara, and the Grishneshwar Temple. Our AC cabs, professional drivers, and well-planned routes ensure you reach your destination safely and on time. Whether you’re traveling for tourism, business, or pilgrimage, we provide multiple cab options to suit every budget and group size. With transparent pricing and flexible booking, Meghana Cab makes your Pune to Sambhajinagar trip smooth and enjoyable."
    },
    {
      "name": "Pune to Paithan Cab Service",
      "description": "Visit the historical and spiritual town of Paithan with Meghana Cab’s Pune to Paithan cab service. Known for the famous Sant Eknath Maharaj Temple and Paithani Sarees, this destination offers both cultural and devotional experiences. Our AC cars and courteous drivers ensure a safe and relaxing journey. Whether you’re planning a family visit, religious trip, or weekend getaway, Meghana Cab offers affordable one-way and round-trip options. Book your Pune to Paithan taxi now and enjoy a comfortable travel experience with timely pickups and reliable service."
    },
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Book a comfortable Pune to Bhimashankar cab with Meghana Cab and visit the sacred Jyotirlinga nestled in the lush Western Ghats. The route offers scenic views, winding ghats, and serene landscapes. Our AC cabs, experienced drivers, and flexible departure timings make your pilgrimage peaceful and convenient. We also offer full-day and round-trip packages for Bhimashankar darshan. Enjoy reliable service, well-maintained vehicles, and affordable fares while you focus on your spiritual journey. Meghana Cab makes your Bhimashankar trip from Pune truly divine and hassle-free."
    },
    {
      "name": "Pune to Trimbakeshwar Cab",
      "description": "Travel from Pune to Trimbakeshwar with Meghana Cab for a comfortable and spiritually enriching trip. Located near Nashik, Trimbakeshwar is one of the twelve Jyotirlingas of Lord Shiva. Our professional drivers and clean, air-conditioned vehicles ensure a smooth and pleasant journey. Whether you’re traveling solo, with family, or as part of a Jyotirlinga tour, we offer flexible schedules and affordable prices. Combine your trip with nearby destinations like Shirdi or Nashik for an extended pilgrimage experience. Book your Pune to Trimbakeshwar cab today for a safe and divine journey."
    },
    {
      "name": "Pune to Shirdi Innova Cab",
      "description": "Meghana Cab offers premium Pune to Shirdi Innova cab services for a luxurious and comfortable pilgrimage to Sai Baba’s temple. Our spacious Innova and Innova Crysta vehicles are ideal for families and groups. Enjoy air-conditioned comfort, ample legroom, and professional chauffeurs familiar with Shirdi routes. The journey includes door-to-door pickup and drop, ensuring a stress-free travel experience. You can also include Nashik or Trimbakeshwar visits in your itinerary. Book your Pune to Shirdi Innova cab today with Meghana Cab and travel in complete comfort and peace."
    },
    {
      "name": "Pune to Grishneshwar Innova Cab",
      "description": "Travel in comfort with Meghana Cab’s Pune to Grishneshwar Innova Cab service. Ideal for family groups and devotees, our Innova and Innova Crysta vehicles offer spacious interiors and smooth rides. Visit the sacred Grishneshwar Jyotirlinga Temple near Ellora Caves with peace and convenience. Our professional drivers are courteous and experienced in handling long-distance temple tours. We also offer packages that combine Grishneshwar with Ajanta, Ellora, or other Jyotirlinga destinations. Book your Innova cab from Pune today for a premium pilgrimage experience."
    },
    {
      "name": "Pune to Grishneshwar Jyotirlinga Tour Package",
      "description": "Experience a divine journey with Meghana Cab’s Pune to Grishneshwar Jyotirlinga Tour Package. This spiritual tour covers the famous Grishneshwar Temple along with nearby attractions like Ellora Caves and Bibi Ka Maqbara. Enjoy comfortable AC cab travel, flexible departure timings, and professional drivers familiar with all temple routes. Perfect for families and devotees seeking a relaxed yet fulfilling darshan experience. Our packages can also be customized to include Trimbakeshwar, Shirdi, or Ajanta. Book your Grishneshwar Jyotirlinga tour package from Pune and travel with peace and devotion."
    },
    {
      "name": "Pune to Nashik Cab Service",
      "description": "Book your Pune to Nashik cab with Meghana Cab for a safe and pleasant intercity journey. Visit Nashik’s spiritual and tourist destinations including Trimbakeshwar Temple, Sula Vineyards, and Panchavati. Our AC cabs, polite drivers, and transparent pricing ensure a stress-free ride. Whether for business, pilgrimage, or leisure, we provide reliable one-way and round-trip cab options. Enjoy door-to-door service and flexible scheduling for your Nashik trip from Pune. Book today with Meghana Cab for comfort, safety, and affordability."
    },
    {
      "name": "Pune Aurangabad Darshan Package",
      "description": "Discover Aurangabad’s rich heritage and temples with Meghana Cab’s Pune Aurangabad Darshan Package. This package covers major attractions like Ellora Caves, Ajanta Caves, Grishneshwar Jyotirlinga Temple, and Bibi Ka Maqbara. Our AC cars, professional chauffeurs, and flexible itineraries make sightseeing comfortable and efficient. Ideal for families, tourists, and pilgrims, the package ensures convenience, safety, and excellent value. Enjoy scenic drives, comfortable stays, and guided routes as you explore Maharashtra’s historic and spiritual gems. Book your Aurangabad Darshan package from Pune with Meghana Cab today."
    }
  ],

  "tableData": [
    ["Pune to Ajanta Ellora Tour Package", "Pune to Grishneshwar Jyotirlinga Cab"],
    ["Pune to 3 Jyotirlinga Tour Package", "Pune to Aurangabad Cab Service"],
    ["Pune to Sambhajinagar Cab Service", "Pune to Paithan Cab Service"],
    ["Pune to Bhimashankar Cab", "Pune to Trimbakeshwar Cab"],
    ["Pune to Shirdi Innova Cab", "Pune to Grishneshwar Innova Cab"],
    ["Pune to Grishneshwar Jyotirlinga Tour Package", "Pune to Nashik Cab Service"],
    ["Pune Aurangabad Darshan Package", ""],
    ["", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Grishneshwar Jyotirlinga Cab Service",
        "WhyChoosedescription": "Meghana Cab offers reliable and comfortable cab services from Pune to the sacred Grishneshwar Jyotirlinga temple, ensuring a smooth and peaceful pilgrimage journey."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop at Grishneshwar",
        "WhyChoosedescription": "We guarantee punctual pick-ups and drop-offs so you can plan your darshan and rituals without any travel delays or hassles."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pilgrimage Routes",
        "WhyChoosedescription": "Our skilled drivers know the Pune to Grishneshwar route well and follow safe driving practices, making your spiritual journey comfortable and secure."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy budget-friendly cab fares for your Pune to Grishneshwar trip with Meghana Cab’s transparent pricing and no surprise costs."
    },
    {
        "WhyChooseheading": "Sanitized and Safe Vehicles for Pilgrims",
        "WhyChoosedescription": "Travel in clean and sanitized cabs equipped with safety features like GPS, seat belts, and emergency support to ensure your safety during the journey."
    },
    {
        "WhyChooseheading": "24/7 Availability for Pilgrimage Travel",
        "WhyChoosedescription": "Whether it’s an early morning darshan or a late-night return, Meghana Cab operates round the clock to meet your Pune to Grishneshwar travel needs."
    },
    {
        "WhyChooseheading": "Flexible Packages for Jyotirlinga Pilgrimage",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-stop packages tailored to your pilgrimage schedule and preferences."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Grishneshwar Jyotirlinga cab easily via our website or app. Our support team is available to assist with any questions or special requests."
    }
]





















    }

const faqData = [
    {
        question: "How can I book a Pune to Grishneshwar Jyotirlinga cab with Meghana Cab?",
        answer: "You can easily book a cab from Pune to Grishneshwar Jyotirlinga through Meghana Cab’s website or by calling our customer support at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Grishneshwar Jyotirlinga?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and travel comfort preferences."
    },
    {
        question: "Is one-way cab service available from Pune to Grishneshwar Jyotirlinga?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services for the Pune to Grishneshwar Jyotirlinga route."
    },
    {
        question: "How long does it take to travel from Pune to Grishneshwar Jyotirlinga by cab?",
        answer: "The travel time is approximately 5 to 6 hours, depending on the traffic and road conditions."
    },
    {
        question: "Are tolls, parking, and taxes included in the cab fare?",
        answer: "Toll charges, parking fees, and applicable taxes are additional and will be clearly mentioned at the time of booking."
    },
    {
        question: "Are the drivers familiar with the Grishneshwar temple route?",
        answer: "Yes, our drivers are experienced and well-versed with pilgrimage routes including Grishneshwar Jyotirlinga near Ellora."
    },
    {
        question: "Can I request stops at other temples or attractions on the way?",
        answer: "Yes, you can request custom stops during the journey. Please share your preferences while booking."
    },
    {
        question: "Is night travel available for Pune to Grishneshwar Jyotirlinga?",
        answer: "Yes, Meghana Cab offers 24/7 services. You can plan early morning, day, or night travel based on your schedule."
    },
    {
        question: "What payment methods are accepted for the cab booking?",
        answer: "We accept payments via UPI, debit/credit cards, net banking, and also cash."
    },
    {
        question: "How do I get help or make changes to my Pune to Grishneshwar cab booking?",
        answer: "You can call Meghana Cab’s support team at +91 9075462128 for assistance with bookings or changes."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Prakash More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our spiritual trip to Grishneshwar Jyotirlinga was made stress-free with Meghana Cab. Clean vehicle, helpful driver, and smooth ride throughout.”',
    },
    {
        name: 'Mrs. Meenal Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for religious travel. The Pune to Grishneshwar cab was punctual and the driver was courteous and knowledgeable about the temple.”',
    },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Grishneshwar Jyotirlinga Cab",
  "description": "Travel comfortably with Meghana Cabs from Pune to Grishneshwar Jyotirlinga. Ideal for spiritual tours including Ajanta Ellora, Bhimashankar, Trimbakeshwar, and more. Book your reliable cab service for a smooth journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3576"
  }
};






    return (
        <div>




<Helmet>
  <title>Pune to Grishneshwar Jyotirlinga Cab | Reliable Cab Service @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Grishneshwar Jyotirlinga cab with Meghana Cabs. Comfortable and affordable cab service for spiritual tours including Ajanta Ellora, Bhimashankar, Trimbakeshwar, Shirdi, and more."
  />
  <meta
    name="keywords"
    content="pune to ajanta ellora tour package, Pune to Grishneshwar Jyotirlinga Cab, pune to 3 jyotirlinga tour package, pune to aurangabad cab service, pune to sambhajinagar cab service, pune to paithan cab service, pune to bhimashankar cab, pune to trimbakeshwar cab, pune to shirdi innova cab, pune to grishneshwar innova cab, pune to grishneshwar jyotirlinga tour package, pune to 3 jyotirlinga tour package, pune to nashik cab service, pune aurangabad darshan package"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogrishneshwarjyotilinga;